module.exports = __webpack_public_path__ + "img/audio.0c805b8c.svg";